var exports = {
  "q": "DiscoveryGuildHeader.module__headerTitle___a0w4eH",
};

module.exports = exports;
